export interface FailureMode {
  id: string;
  name: string;
  description?: string;
}

export interface AssetType {
  id: string;
  name: string;
  description?: string;
  failureModes: FailureMode[];
}

export interface AssetClass {
  code: string;
  name: string;
  description?: string;
  assetTypes: any[];
}

// Default data for the asset classifications
export const DEFAULT_ASSET_CLASSIFICATIONS: AssetClass[] = [
  {
    code: "mechanical-equipment",
    name: "Mechanical Equipment",
    description: "Equipment with moving mechanical parts and systems",
    assetTypes: [
      {
        id: "pumps",
        name: "Pumps",
        description: "Fluid transportation equipment",
        failureModes: [
          {
            id: "bearing-failure",
            name: "Bearing Failure",
            description:
              "Deterioration of pump bearings due to wear or contamination",
          },
          {
            id: "seal-leakage",
            name: "Seal Leakage",
            description: "Failure of mechanical seals allowing fluid escape",
          },
          {
            id: "impeller-damage",
            name: "Impeller Damage",
            description: "Physical damage or wear to the pump impeller",
          },
        ],
      },
      {
        id: "motors",
        name: "Motors",
        description: "Electric and mechanical motors",
        failureModes: [
          {
            id: "winding-failure",
            name: "Winding Failure",
            description:
              "Electrical winding insulation breakdown or short circuit",
          },
          {
            id: "rotor-imbalance",
            name: "Rotor Imbalance",
            description: "Unbalanced rotor causing vibration and wear",
          },
        ],
      },
    ],
  },
  {
    code: "electrical-equipment",
    name: "Electrical Equipment",
    description: "Electrical systems and components",
    assetTypes: [
      {
        id: "transformers",
        name: "Transformers",
        description: "Voltage transformation equipment",
        failureModes: [
          {
            id: "insulation-breakdown",
            name: "Insulation Breakdown",
            description:
              "Failure of electrical insulation leading to short circuits",
          },
          {
            id: "oil-degradation",
            name: "Oil Degradation",
            description:
              "Degradation of transformer oil affecting cooling and insulation",
          },
        ],
      },
    ],
  },
  {
    code: "instrumentation",
    name: "Instrumentation",
    description: "Measurement and control instruments",
    assetTypes: [
      {
        id: "pressure-sensors",
        name: "Pressure Sensors",
        description: "Devices for measuring pressure",
        failureModes: [
          {
            id: "sensor-drift",
            name: "Sensor Drift",
            description: "Gradual change in sensor accuracy over time",
          },
          {
            id: "diaphragm-rupture",
            name: "Diaphragm Rupture",
            description: "Physical failure of the pressure sensing diaphragm",
          },
        ],
      },
    ],
  },
];

export interface Dimension {
  name: string;
  data_type: "number" | "text" | "dropdown" | "date";
  is_required: boolean;
  code: string;
  unit?: string;
  options?: string[];
  remote_utility_id: number;
  asset_type_characteristics: "dimensions";
}

export interface AssetTypeDimension {
  id: string;
  assetClass: string;
  assetType: string;
  dimensions: Dimension[];
}
